<script lang="ts">
    import { Table } from 'sveltestrap'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import {polygonDeposits} from 'src/components/cabinet/#services/evmAdapter'
    import {copyClipboard} from 'src/global/copyClipboard'
    import IconifyIcon from '@iconify/svelte'
    import copyIcon from '@iconify/icons-fa-solid/copy'
    import successIcon from '@iconify/icons-fa-solid/check-circle'
    import pendingIcon from '@iconify/icons-fa-solid/spinner'
    import pauseIcon from '@iconify/icons-fa-solid/pause'
    import errorIcon from '@iconify/icons-fa-solid/exclamation-circle'
    import {roundNumber} from 'src/components/#common/helpers'

    export let userId

    let currentPage = 0
    let perPage = 25
    let maxButtons = 5
    let totalCount = 5

    $: polygonDeposits.send({
        data: {
            userId,
            page: currentPage + 1,
            perPage,
        },
    })

    async function copy(value) {
        copyClipboard(value)
    }
</script>


<Table bordered striped responsive>
    <thead>
        <tr>
            <td class="text-center">Amount</td>
            <td class="text-center">Wallet</td>
            <td class="text-center">On balance</td>
            <td class="text-center">On a cold wallet</td>
            <td class="text-center">Date</td>
        </tr>
    </thead>
    <tbody>
    {#if $polygonDeposits.loading}
        {#each {length:perPage} as item}
            <tr>
                <td><span class="loading transaction-loading"></span></td>
                <td><span class="loading transaction-loading"></span></td>
                <td><span class="loading transaction-loading"></span></td>
                <td><span class="loading transaction-loading"></span></td>
                <td><span class="loading transaction-loading"></span></td>
            </tr>
        {/each}
    {:else if $polygonDeposits.error || !$polygonDeposits.hasValue }
        <tr>
            <td class="text-center" colspan="5">Something went wrong. Try refreshing the page.</td>
        </tr>
    {:else}
        {#each $polygonDeposits.value.data as {id, amount, currency, isSentToColdWallet, receiverId, sentToTransactionStatus, transactionHash, userId, createdAt}}
            <tr>
                <td class="text-center">{roundNumber(+amount)} {currency === 'WLIS' ? 'LIS' : currency}</td>
                <td class="text-center">
                    {#if transactionHash}
                        <a href="https://polygonscan.com/tx/{transactionHash}" class="address notranslate" target="_blank" rel="noreferrer">
                            {#if receiverId.length >= 20}
                                {receiverId.slice(0,7)}...{receiverId.slice(-7)}
                            {:else}
                                {receiverId}
                            {/if}
                        </a>
                    {:else}
                        <a href="https://polygonscan.com/address/{receiverId}" class="address notranslate" target="_blank" rel="noreferrer">
                            {#if receiverId.length >= 20}
                                {receiverId.slice(0,7)}...{receiverId.slice(-7)}
                            {:else}
                                {receiverId}
                            {/if}
                        </a>
                    {/if}
                    <button class="btn copy-btn" on:click={copy(receiverId)}>
                        <IconifyIcon icon={copyIcon} class="side-nav-icon"/>
                    </button>
                </td>
                <td class="text-center">
                    {#if sentToTransactionStatus === 'NOT_SENT'}
                        <span class="status-icon status-pending" title="Not sent">
                            <IconifyIcon icon={pauseIcon}/>
                        </span>
                    {:else if sentToTransactionStatus === 'IS_SENDING'}
                        <span class="status-icon status-pending" title="Pending">
                            <IconifyIcon icon={pendingIcon}/>
                        </span>
                    {:else if sentToTransactionStatus === 'SENT'}
                        <span class="status-icon status-success" title="Sent">
                            <IconifyIcon icon={successIcon}/>
                        </span>
                    {:else if sentToTransactionStatus === 'ERROR'}
                        <span class="status-icon status-error" title="Error">
                            <IconifyIcon icon={errorIcon}/>
                        </span>
                    {/if}
                </td>
                <td class="text-center">
                    {#if isSentToColdWallet === 'NOT_SENT'}
                        <span class="status-icon status-pending" title="Not sent">
                            <IconifyIcon icon={pauseIcon}/>
                        </span>
                    {:else if isSentToColdWallet === 'SENT'}
                        <span class="status-icon status-success" title="Sent">
                            <IconifyIcon icon={successIcon}/>
                        </span>
                    {:else if isSentToColdWallet === 'ERROR'}
                        <span class="status-icon status-error" title="Error">
                            <IconifyIcon icon={errorIcon}/>
                        </span>
                    {/if}
                </td>
                <td class="text-center">{new Date(createdAt).toLocaleString()}</td>
            </tr>
        {:else}
            <tr>
                <td class="text-center" colspan="5">No items</td>
            </tr>
        {/each}
    {/if}
    </tbody>
</Table>
{#if $polygonDeposits.hasValue}
    <Pagination
        bind:currentPage={currentPage}
        totalCount={$polygonDeposits.value.totalCount}
        {perPage}
        {maxButtons}
        disabled={$polygonDeposits.loading || $polygonDeposits.loading}
    />
{/if}

<style>
    .status-icon {
        font-size: 16px;
    }

    .copy-btn {
        font-size: 14px;
        line-height: 11px;
        background: #8391a2;
        color: white;
        padding: 4px 5px;
        margin: -4px 0 -3px 4px;
        transition: .15s;
    }

    .copy-btn:hover {
        background: #768494;
    }

    .status-success {
        color: #27AE60;
    }

    .status-pending {
        color: #ff9800;
    }

    .status-error {
        color: #da4848;
    }

    .copy-btn {
        font-size: 14px;
        line-height: 11px;
        background: #8391a2;
        color: white;
        padding: 4px 5px;
        margin: -4px 0 -3px 4px;
        transition: .15s;
    }

    .copy-btn:hover {
        background: #768494;
    }
</style>
